// Map an API error to a user-facing French message. Centralises the special cases
// (writes-disabled, duplicate, system-role read-only) the write actions surface.

import { ApiError } from "../api/client.js"
import { fr } from "../i18n/fr.js"

export function messageForError(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    if (err.isWritesDisabled) return fr.app.writesDisabledError
    if (err.code === "system_role_readonly") return fr.roles.edit.systemReadonly
  }
  return fallback
}

/** Detect a unique-name conflict from the API (Postgres 23505 surfaces as 500). */
export function isDuplicateError(err: unknown): boolean {
  return err instanceof ApiError && (err.code === "duplicate" || err.status === 409)
}
